import api from "../services/api";
import backEnd from "../constants/backEnd";
import endpoints from "../constants/endpoints";

export async function getSubscriptionType(currency) {
    return api
        .get(`${backEnd.url}${endpoints.access.subscriptionType}`, { params: { currency: currency } })
        .then((response) => {
            return { type: "success", data: response.data };
        })
        .catch((error) => {
            console.error('getSubscriptionType error:', error);
            return {
                type: "error",
                data: {
                    code: error.response?.data?.code || 'unknown_error',
                    detail: error.response?.data?.detail || error.message || 'Failed to fetch subscription types',
                },
            };
        });
}
